import { api } from "constants/RotasAPI";
import useDelete from "hooks/useDelete";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ExcluirAgendamentoDTO } from "types/dto/ExcluirAgendamentoDTO";
import { ResponseDTO } from "types/dto/ResponseDTO";

export const useDeleteAgendamentoContato = () => {
  const onSuccess = (request: number, resposne: ResponseDTO<ExcluirAgendamentoDTO>) => {
    if (resposne.errorMessage) {
      toast.error(resposne.errorMessage);
    } else {
      toast.success("Agendamento excluído com sucesso!");
      queryClient.invalidateQueries(["agendamentos-contatos"]);
      queryClient.invalidateQueries(["informacoes-agendamento"]);
    }
  };

  return useDelete<number>({
    url: api.agendamentoContato.deleteAgendamentoContato,
    onSuccess,
  });
};
